<template>
  <section class="c-section c-section--blog pb-5">
    <div class="container">
      <div class="c-banner-top d-flex flex-column
          justify-content-center px-5 py-3 mt-0">
          <h2 class="fs-35 w-sbold gray-lightx mb-3 mb-md-5" v-if="context.banner_top">
            {{context.banner_top.title}}
          </h2>
          <div class="c-banner-top__text">
            <router-link to="/" class="c-link gray-light">
              Inicio
            </router-link>
            <span>
              /
            </span>
            <router-link to="/blog" class="c-link gray-light">
              Blog
            </router-link>
          </div>
        <div
          class="c-banner-top__container d-none d-md-block"
          :style="`background-image:url(${context.banner_top.image.url})`"
          >
        </div>
      </div>
      <section>
        <div class="mb-4">
          <div class="row align-items-center gy-4">
            <div class="col-12 col-md-6" v-if="context.banner">
              <h2 class="sec-dark w-sbold fs-25">
                {{context.banner.title}}
              </h2>
              <p class="sec-dark w-regular fs-16">
                {{context.banner.description}}
              </p>
            </div>
            <div class="col-12 col-md-6">
              <p class="black w-regular fs-16 text-end mb-4">
                Compartir en:
              </p>
              <div class="d-flex justify-content-end">
                <div class="c-social c-social--gray">
                  <a
                    :href="getSocialShare('facebook')"
                    target="_blank"
                    class="c-social__icon">
                    <Icon icon="cib:facebook-f" />
                  </a>
                  <a
                    :href="getSocialShare('twitter')"
                    target="_blank"
                    class="c-social__icon">
                    <Icon icon="akar-icons:twitter-fill" />
                  </a>
                  <a
                    :href="getSocialShare('whatsapp')"
                    target="_blank"
                    class="c-social__icon">
                    <Icon icon="akar-icons:whatsapp-fill" />
                  </a>
                  <a
                    :href="getSocialShare('linkedin')"
                    target="_blank"
                    class="c-social__icon me-0">
                    <Icon icon="akar-icons:linkedin-fill" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="c-hr mb-4"></div>
        <div class="d-lg-flex justify-content-between align-items-center mb-4">
          <div class="d-md-flex align-items-center justify-content-between
            justify-lg-content-end">
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-lg-8 order-2 order-lg-1">
            <div class="d-flex align-items-center justify-content-between pt-3 mb-4">
              <div>
                <b-dropdown
                  size="sm"
                  variant="link"
                  toggle-class="text-decoration-none"
                  no-caret>
                  <template #button-content class="outline-none">
                    <span class="fs-16 sec-medium w-regular d-flex align-items-center">
                      <Icon
                        icon="carbon:settings-adjust"
                        class=""/>
                        Ordenar por:
                    </span>
                  </template>
                  <b-dropdown-item
                    href="#"
                    @click.prevent="filter.order = 1"
                  >
                    <p
                      class="d-flex sec-medium fs-16 w-regular mb-0
                        align-items-center">
                      Mas recientes
                    </p>
                  </b-dropdown-item>
                  <b-dropdown-item
                    href="#"
                    @click.prevent="filter.order = 2"
                  >
                    <p
                      class="d-flex sec-medium fs-16 w-regular mb-0
                        align-items-center">
                      Mas antiguos
                    </p>
                  </b-dropdown-item>
                </b-dropdown>
              </div>
              <div class="d-flex">
                <router-link
                  to="/blog"
                  @click="getArticles(0)"
                  class="c-link c-link--primary"
                >
                  Todos
                </router-link>
              </div>
            </div>

            <section class="mb-5">
              <b-skeleton-wrapper :loading="articles.isLoading">
                <template #loading>
                  <div class="row gy-5">
                    <div
                      v-for="article of [1,2,3,4,5,6,7,8,9]"
                      :key="`article-sk-${article}`"
                      class="col-12 col-md-6"
                    >
                      <b-card>
                        <div class="row gy-2">
                          <div class="col-12">
                            <b-skeleton-img aspect="16:9"></b-skeleton-img>
                          </div>
                          <div class="col-12">
                            <b-skeleton height="20px"></b-skeleton>
                          </div>
                          <div class="col-12">
                            <b-skeleton width="80%" height="20px"></b-skeleton>
                          </div>
                          <div class="col-12">
                            <div class="d-flex justify-content-between">
                              <b-skeleton type="avatar"></b-skeleton>
                              <b-skeleton width="100px" height="40px"></b-skeleton>
                            </div>
                          </div>
                        </div>
                      </b-card>
                    </div>
                  </div>
                </template>

                <template v-if="articles.data.length">
                  <div class="row gy-4">
                    <div
                      v-for="article of articles.data"
                      :key="`article-${article.id}`"
                      class="col-12 col-md-6"
                    >
                      <div class="c-category d-flex flex-column h-100">
                        <div class="mb-3">
                          <router-link :to="`/blog/${article.slug}`" class="c-category__content">
                            <figure class="c-category__figure">
                              <img
                                :src="article.thumbnail"
                                alt=""
                                class="w-100 h-100 if--cover"
                              />
                              <div class="c-category__backgraund">
                                <div>
                                  <p class="fs-21 w-sbold white mb-0">
                                    Ver el artículo
                                  </p>
                                  <p class="fs-21 w-sbold white text-center mb-0">
                                    <Icon icon="bi:eye"/>
                                  </p>
                                </div>
                              </div>
                              <div class="c-category__texts">
                                <p class="c-category__text-1 mb-0">
                                  {{
                                    article.categories
                                      ? article.categories[0].name
                                      : 'Sin categoría'
                                  }}
                                </p>
                                <p class="c-category__text-2 mb-0">
                                  {{article.date}}
                                </p>
                              </div>
                            </figure>
                          </router-link>
                        </div>
                        <div class="d-flex flex-column flex-grow-1 justify-content-between">
                          <div class="mb-3">
                            <router-link
                              :to="`/blog/${article.slug}`"
                              class="c-category__link py-4"
                            >
                              {{article.title}}
                            </router-link>
                          </div>
                          <div v-if="false" class="d-flex mb-3">
                            <p
                              class="sec-light fs-14 w-regular me-2 mb-0
                                d-flex align-items-center"
                            >
                              <span class="me-2 d-flex">
                                <Icon icon="bx:message"/>
                              </span>
                              5 Comentarios
                            </p>
                            <p class="sec-light fs-14 w-regular mb-0 d-flex align-items-center">
                              <span class="me-2 d-flex">
                                <Icon icon="bi:suit-heart"/>
                              </span>
                              99 les gusta
                            </p>
                          </div>
                          <div class="d-flex justify-content-between align-items-center">
                            <div class="d-flex">
                              <figure class="c-category__profile me-2">
                                <img
                                  :src="article.author.avatar
                                    ? article.author.avatar.url
                                    : require('@/assets/img/profile/user.png')"
                                  alt=""
                                  class="w-100 h-100 of--cover">
                              </figure>
                              <div
                              class="d-flex align-items-start justify-content-center flex-column">
                                <h2 class="sec-medium fs-16 w-sbold mb-0">
                                  {{article.author.first_name}}
                                  {{article.author.last_name}}
                                </h2>
                                <p class="sec-light fs-14 w-regular mb-0">
                                  {{article.author.role}}
                                </p>
                              </div>
                            </div>
                            <div class="d-flex">
                              <router-link
                                :to="`/blog/${article.slug}`"
                                class="c-button c-button--primary"
                              >
                                Leer más
                              </router-link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
                <template v-else>
                  <p class="mb-0 text-center">
                    Sin articulos, pruebe con otra busqueda
                    <Icon icon="noto:sad-but-relieved-face" class="ms-2" />
                  </p>
                </template>
              </b-skeleton-wrapper>
            </section>

            <b-pagination
              v-model="articles.paged"
              :total-rows="articles.paginationTotal"
              :per-page="articles.perPage"
              align="center"
            ></b-pagination>
          </div>
          <div class="col-12 col-lg-4 order-1 order-lg-2">
            <div class="c-banner-top c-banner-top--primary
              d-flex flex-column
                justify-content-center py-3 ps-4 m-0 mb-4">
                <div class="c-banner-top__text me-5 pe-4">
                  <router-link to="/membresias" class="c-link c-link--white">
                    Obtén una membresía Aquí
                  </router-link>
                </div>
              <div class="c-banner-top__container">
              </div>
            </div>
            <div class="c-form-group">
              <div class="d-flex justify-content-center">
                <input
                  v-model="filter.search"
                  @keyup.delete="clean()"
                  @keyup.enter="search()"
                  type="text"
                  class="c-form-group__input"
                  placeholder="¿Qué deseas aprender hoy?"
                />
                <button
                  @click="search()"
                  class="c-button c-button--search"
                >
                  <span class="d-flex justify-content-center">
                    <Icon icon="ph:magnifying-glass-light" class="d-flex"/>
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </section>
</template>

<script>
import { Icon } from '@iconify/vue2';

export default {
  data() {
    return {
      context: {},
      contextLoading: true,

      filter: {
        order: 1,
        search: '',
      },

      articles: {
        isLoading: false,
        isLoadingMore: false,

        data: [],
        paged: 1,
        perPage: 1,
        paginationTotal: 5,
      },
    };
  },
  components: {
    Icon,
  },
  computed: {
    filterQueries() {
      let filterQueries = '';

      if (this.filter.search) {
        filterQueries += `&search=${this.filter.search}`;
      }

      if (this.filter.order) {
        filterQueries += `&order=${this.filter.order}`;
      }

      return filterQueries;
    },
  },
  created() {
    this.getFullContext({ type: 'page', slug: 'blog' });
  },
  watch: {
    'filter.order': function filterOrder() {
      this.getArticles();
    },
    'articles.paged': function articlesPaged() {
      this.getArticles();
    },
  },
  mounted() {
    this.getArticles();
  },
  methods: {
    getArticles() {
      const request = `${process.env.VUE_APP_API}/articles?paged=${this.articles.paged}${this.filterQueries}`;

      this.articles.isLoading = true;

      fetch(request)
        .then((res) => {
          if (res.status === 201 || res.status < 300) {
            return res.json();
          }

          throw res;
        })
        .then((response) => {
          this.articles.paginationTotal = response.data.pagination.total;

          if (response.status) {
            this.articles.data = response.data.articles;
            console.log(this.articles.data, 'bbb');
          } else {
            this.articles.data = [];
            console.log(this.articles.data, 'ccc');
          }

          console.log(this.articles.data, 'aaaa');
        })
        .catch((err) => {
          this.articles.data = [];
          this.articles.paginationTotal = 0;

          throw err;
        })
        .finally(() => {
          this.articles.isLoading = false;
          this.articles.isLoadingMore = false;
        });
    },
    getSocialShare(social) {
      let baseShare = '';

      switch (social) {
        case 'facebook':
          baseShare = 'https://www.facebook.com/sharer/sharer.php?u=';
          break;

        case 'twitter':
          baseShare = 'https://twitter.com/share?text=Enterate del mundo del Agro en&url=';
          break;

        case 'linkedin':
          baseShare = 'https://www.linkedin.com/sharing/share-offsite/?url=';
          break;

        case 'whatsapp':
          baseShare = 'https://api.whatsapp.com/send?text=Enterate del mundo del Agro en, ';
          break;

        default:
          baseShare = '';
          break;
      }

      return (baseShare)
        ? `${baseShare}${process.env.VUE_APP_SITE}${this.$route.path}`
        : '#';
    },

    search() {
      if (this.filter.search) {
        this.getArticles();
      }
    },
    clean() {
      if (!this.filter.search) {
        this.getArticles();
      }
    },
  },
};
</script>
